export const codePhoneNumber = (phone: string): string =>
  phone
    .split('')
    .map((symbol, index, array) => {
      if (/\D/.test(symbol)) {
        return symbol;
      }
      if (index > 2 && index < array.length - 2) {
        return '*';
      }

      return symbol;
    })
    .join('');
